import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

export const MessageAdd = ({ open, handleClose, goClient, message, repeat }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" align='center'>
                {repeat ? message?.messageUniqueKey : message.messageTitle}
            </DialogTitle>

            <DialogActions>
                <Button onClick={handleClose}>{message.buttonLeft}</Button>
                <Button onClick={goClient} autoFocus>
                {message.buttonRight}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
